<template>
  <svg class="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 13.5V13.4577C12 12.5534 12.4745 11.7153 13.25 11.25L13.415 11.151C14.0881 10.7471 14.5 10.0197 14.5 9.23472C14.5 8.00052 13.4995 7 12.2653 7H12C10.6193 7 9.5 8.11929 9.5 9.5M12 16V16.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke-width="2" stroke-linecap="round"/>
  </svg>
</template>